// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"circleLogoLoader_wrapper__PlT5j","spin":"circleLogoLoader_spin__4SiAM"};